/**
 * Business facts and shared site content for the public website (Feature #25438).
 *
 * Provenance: docs/retrofit-capture/gp001-public-website-baseline.md § 4 — every value is what the
 * legacy greatwaypatios.com.au states. No year of establishment is shown anywhere (the legacy site
 * contradicts itself — 1989 vs 1991; BR-WEB-006).
 */

export const BUSINESS = {
  name: "Greatway Patios",
  phone: "(07) 4636 1766",
  /** BR-WEB-003 — every rendering of the phone number links here. */
  tel: "tel:+61746361766",
  email: "reception@greatwaypatios.com.au",
  street: "396 South Street",
  town: "Toowoomba",
  state: "Queensland",
  postcode: "4350",
  hours: "Mon–Fri 9:00am – 4:00pm",
  qbcc: "24037",
  serviceArea: ["Toowoomba", "Darling Downs", "Lockyer Valley"],
  facebook: "https://www.facebook.com/Greatway-Patios-123166831349961/",
} as const;

export type RangeId = "roofs-and-patios" | "screens-and-shade" | "living-spaces";

export interface Range {
  id: RangeId;
  name: string;
}

/** The three product ranges, in display order (new information architecture — baseline § 5). */
export const RANGES: readonly Range[] = [
  { id: "roofs-and-patios", name: "Roofs & patios" },
  { id: "screens-and-shade", name: "Screens & shade" },
  { id: "living-spaces", name: "Living spaces" },
];

const IMG = "/images/website/";

/** Banners, logo and supplier logos (EXIF-stripped copies under public/images/website/**). */
export const IMAGES = {
  bannerAbout: `${IMG}banner/about-us-banner.jpg`,
  bannerContact: `${IMG}banner/img-06881221.jpg`,
  bannerProducts: `${IMG}banner/img-889712.jpg`,
  homeVergola: `${IMG}banner/dullawayvergola00.jpg`,
  homeBanner2: `${IMG}banner/new-banner2.jpg`,
  homeBanner3: `${IMG}banner/banner-03.jpg`,
  homeBanner002: `${IMG}banner/banner002.jpg`,
  homeBanner004: `${IMG}banner/banner004.jpg`,
  logo: `${IMG}brand/logo-greatway.png`,
  logoAusdeck: `${IMG}brands/ausdeck.png`,
  logoVergola: `${IMG}brands/vergola.png`,
  logoIntelliscreens: `${IMG}brands/intelliscreens.png`,
  logoZiptrak: `${IMG}brands/ziptrak.png`,
  logoSuperiorScreens: `${IMG}brands/superior-screens.png`,
} as const;

/** Supplier brands shown on the home page, in legacy order. */
export const BRANDS: readonly { name: string; logo: string }[] = [
  { name: "Vergola", logo: IMAGES.logoVergola },
  { name: "Ziptrak", logo: IMAGES.logoZiptrak },
  { name: "Ausdeck", logo: IMAGES.logoAusdeck },
  { name: "Intelliscreens", logo: IMAGES.logoIntelliscreens },
  { name: "Superior Screens", logo: IMAGES.logoSuperiorScreens },
];

/** Every "Free quote" call to action routes here (BR-WEB-002). */
export function quotePath(productSlug?: string): string {
  return productSlug ? `/enquire?product=${encodeURIComponent(productSlug)}` : "/enquire";
}

/** Appends the site name to a page title, as every legacy-derived title does. */
export const SITE_TITLE_SUFFIX = " | Greatway Patios";
